module.exports = __webpack_public_path__ + "static/media/Oliver_Tiede.4632f82c.jpg";